

















import { defineComponent, ref, PropType } from "@vue/composition-api";

export default defineComponent({
  name: "ElementEditor",
  props: {
    data: {
      type: Object as PropType<{ [name: string]: string }>,
      default: () => ({})
    }
  },
  setup(
    props: {
      data: { [name: string]: string };
    },
    { emit }
  ) {
    const newAttr = ref({
      name: "",
      val: ""
    });
    const addAttr = () => {
      if (newAttr.value.name === "") return false;
      if (newAttr.value.val === "") return false;
      emit("add", newAttr.value);
      newAttr.value.name = "";
      newAttr.value.val = "";
    };

    const updateAttr = (name: string, value: string) =>
      emit("update", { name, value });

    const removeAttr = (key: string) => emit("remove", key);
    return {
      newAttr,
      removeAttr,
      updateAttr,
      addAttr,
      close: () => emit("close")
    };
  }
});
